
import axios from '../plugins/axiosPlugins'

import runEvn from '../modular/runEvn/RunEvn'
const baseURL = runEvn().apiBaseUrl;

/**
 * Couser详情
 * @returns 
 */
 export const GetVideoToken = (videoId):Promise <any>  => {
    return axios.get(`${baseURL}/Video/GetVideoToken`,{params:{videoId}});
}




